// extracted by css-extract-rspack-plugin
export default {"resultItem":"axxhJGLwdUIW5Fxd","resultItemHighlighted":"XBKb3Rq0ji0VwVBj","resultItemLink":"CwI2D9q3NFwj8w8D"};